import { useEffect, useMemo, useState } from "react";

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const usePagination = (items = [], pageSize = 10) => {
  const [page, setPage] = useState(1);

  const totalPages = useMemo(
    () => Math.max(1, Math.ceil(items.length / pageSize)),
    [items.length, pageSize]
  );

  useEffect(() => {
    setPage(1);
  }, [items, pageSize]);

  useEffect(() => {
    setPage((current) => clamp(current, 1, totalPages));
  }, [totalPages]);

  const pageItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, page, pageSize]);

  const goToPage = (nextPage) => setPage((prev) => clamp(nextPage ?? prev, 1, totalPages));
  const nextPage = () => setPage((prev) => clamp(prev + 1, 1, totalPages));
  const prevPage = () => setPage((prev) => clamp(prev - 1, 1, totalPages));

  return { page, totalPages, pageItems, goToPage, nextPage, prevPage, pageSize };
};

export default usePagination;
